import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';
import TagManager from "react-gtm-module";
import cookies from '../../utils/cookies';
import { CONSENT_CHANGED_EVENT } from "@/services/consent";

const AnalyticsProvider = () => {
  const location = useLocation();
  const settings = useSettingsContext();
  const gtmInitialized = useRef(false);
  const [consentRevision, setConsentRevision] = useState(0);

  useEffect(() => {
    const handleConsentChanged = () => setConsentRevision((revision) => revision + 1);
    window.addEventListener(CONSENT_CHANGED_EVENT, handleConsentChanged);
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, handleConsentChanged);
  }, []);

  useEffect(() => {
    if (settings?.analytics?.gtmKey && !gtmInitialized.current) {
      TagManager.initialize({ gtmId: settings.analytics.gtmKey });
      gtmInitialized.current = true;
    }
  }, [settings]);

  useEffect(() => {
    try {
      cookies.updateStatisticScripts(settings);
      cookies.updateMarketingScripts(settings);
    } catch (error) {
      console.debug('Analytics tracking error:', error);
    }
  }, [consentRevision, location, settings]);

  return null;
};

export default AnalyticsProvider;
